import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcAzureOperation, RpcAzureOperationResult, RpcAzureRequestKey } from './rpc-azure-model';
import { RpcAzureRequestHandler } from './rpc-azure-request-handler';

/**
 * Rpc azure request subject interface.
 */
export interface RpcAzureRequestSubject extends Subject<DeferredData<RpcAzureOperation, RpcAzureOperationResult>> {}

/**
 * The class to implement RpcAzureRequest with Subject server.
 */
export class RpcAzureRequestSubjectServer
            extends RpcSubjectServer<RpcAzureOperation, RpcAzureOperationResult>
            implements RpcAzureRequestHandler {

    /**
     * Initializes a new instance of the RpcAzureRequestSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcAzureRequestKey.command);
    }

    /**
     * The handler to respond a request for RpcAzureRequest call.
     *
     * @param data The RPC azure operation object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcAzureOperation): Promise<RpcAzureOperationResult> {
        return this.processNextForSubject(RpcAzureRequestKey.command, data);
    }
}
